import { useCallback, useEffect, useState } from 'react';
import { getAboutUs } from '../services/aboutUs';
import { mapAboutUs } from '../utils/contentMappers';

export function useAboutUs() {
  const [aboutUs, setAboutUs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAboutUs = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await getAboutUs();

      if (response?.success === false) {
        setAboutUs(mapAboutUs(response));
        setError(response?.message || 'About Us content is unavailable right now.');
        return;
      }

      const mapped = mapAboutUs(response);

      if (!mapped.content) {
        setAboutUs(mapped);
        setError('About Us content is unavailable right now.');
        return;
      }

      setAboutUs(mapped);
    } catch (e) {
      setAboutUs(null);
      setError(e?.message || 'Failed to load About Us');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAboutUs();
  }, [fetchAboutUs]);

  return { aboutUs, loading, error, refetch: fetchAboutUs };
}
